<script>
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
import axios from "axios";
export default {
  components: { InputRut, InputRegion },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,
    editar: Function,
    estados: Object,
  },
  data() {
    return {
      condicion: 0,
      extraportuario: "",
      aforo: "0",
      pantalla: false,

      sub_tipo: "",

      listaTipoImportacion: [],
      listaTipoExportacion: [],
    };
  },
  mounted() {
    this.aforo = this.despacho?.aforo.toString()
    this.getSubTipos();
    if (screen.width <= 660) this.pantalla = false;
    else this.pantalla = true;
  },
  methods: {
    async getSubTipos() {
      await axios
        .get("api/despachos/subtipos")
        .then((resp) => {
          this.listaTipoImportacion = resp.data.importaciones;
          this.listaTipoExportacion = resp.data.exportaciones;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<template>
  <div>
    <div class="flex flex-col space-y-2">
      <div
        v-if="despacho.tipo_inspeccion_aforo"
        class="grid grid-cols-5 w-full"
      >
        <div class="text-left">
          <p>Tipo de inspección de aforo</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p>{{ despacho?.tipo_inspeccion_aforo?.nombre ?? "-" }}</p>
        </div>
        <div class="mx-auto">
          <button
            disabled
            @click="editar('presentador_imp', 'aforo')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 p-4 gap-4">
        <div>
          <label>Tipo de aforo</label>
          <select id="aforo-select" v-model="aforo" required>
            <option value="3" disabled>Selecciona el Tipo de Aforo</option>
            <option value="2">Sin Aforo</option>
            <option value="1">Examen Físico</option>
            <option value="0">Examen Documental</option>
          </select>
        </div>
        <div class="flex flex-row gap-4 mt-auto">
          <button
            class="btn-principal"
            type="button"
            @click="editar('presentador_imp', 'aforo', true, { aforo: aforo })"
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('presentador_imp', 'aforo')"
          >
            Cancelar
          </button>
        </div>
      </div>
      <div
        class="grid grid-cols-5 w-full"
        v-if="
          despacho.tipo &&
          despacho.tipo.subtipo &&
          despacho.tipo.subtipo.tipo_operacion &&
          estados.sub_tipo
        "
      >
        <div class="text-left">
          <p>Sub Tipo</p>
        </div>
        <div class="col-span-3 text-right font-bold uppercase">
          <p v-if="despacho.tipo.subtipo.tipo_operacion">
            {{ despacho.tipo.subtipo.tipo_operacion }}
          </p>
        </div>
        <div class="mx-auto">
          <button
            @click="editar('presentador_imp', 'sub_tipo')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 p-4 gap-4">
        <div>
          <label>Subtipo</label>
          <select
            v-if="despacho.tipo_despacho == 'importacion'"
            id="sub_tipo-select"
            v-model="sub_tipo"
            required
          >
            <option value="0" disabled>
              Selecciona el Sub Tipo Importación
            </option>
            <option
              :key="index"
              v-for="(sub_tipo, index) in listaTipoImportacion"
              :value="sub_tipo.id"
            >
              {{ sub_tipo.tipo_operacion }}
            </option>
          </select>

          <select
            v-if="despacho.tipo_despacho == 'exportacion'"
            id="sub_tipo-select"
            v-model="sub_tipo"
            required
          >
            <option value="0" disabled>
              Selecciona el Sub Tipo Exportación
            </option>

            <option
              :key="index"
              v-for="(sub_tipo, index) in listaTipoExportacion"
              :value="sub_tipo.id"
            >
              {{ sub_tipo.tipo_operacion }}
            </option>
          </select>
        </div>

        <div class="flex flex-row items-center gap-2">
          <button
            class="mt-auto btn-principal"
            type="button"
            @click="
              editar('presentador_imp', 'sub_tipo', true, {
                tipo_id: sub_tipo,
              })
            "
          >
            Guardar
          </button>
          <button
            class="mt-auto btn-secundario"
            type="button"
            @click="editar('presentador_imp', 'sub_tipo')"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
